import React, { useEffect, useState } from "react";
import { callApi } from "../../services/ApiServices";
import CommonPagination from "../common/CommonPagination";
import { ImagePath } from "../common/ImagePath";
import CommonLoader from "../common/CommonLoader";
import { useGlobalStates } from "../../utlis/ClubsContext";
import { formatTimestamp } from "../../utlis/function";
import { useNavigate } from "react-router-dom";

const OrdersTab = () => {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const[loading, setLoading] = useState(false)
  const{selectedClub} = useGlobalStates()
  const navigate = useNavigate();
  const limit = 3;

  useEffect(() => {
    fetchOrders(currentPage, limit);
  }, []);

  const fetchOrders = async (page, limit) => {
    try {
      setLoading(true)
      let apiUrl = `admin/club/${selectedClub?.id}/orders?page=${page}&limit=${limit}`;
      const response = await callApi({
        method: "get",
        url: apiUrl,
      });
      setOrders(response?.data);
      const totalItems = response?.pagination?.total;
      const totalPages = Math.ceil(totalItems / limit);
      setTotalCount(totalPages);
    } catch (error) {
      console.log("get orders error", error);
    }finally{
      setLoading(false)
    }
  };
console.log("Total Pages:", totalCount);
    const getOrderStatus = (status) => {
  if (!status) return "Unknown";

  switch (status.toUpperCase()) {
    case "ACTIVE":
      return "Active";
    case "Completed":
      return "Completed";
    case "EXPIRED":
      return "Expired";
    case "CANCELLED":
      return "Cancelled";
    default:
      return status;
  }
};
  const OnPageChange = (page) => {
    setCurrentPage(page);
    fetchOrders(page, limit);
  };
  return (
    <>
      {/* Order Header */}
      {loading && 
      <div className="flex justify-center mt-10">
        <CommonLoader />
        </div>
      }
      {orders?.length > 0 ? (
        <div className="space-y-8">
        {orders?.map((order, index) => (
          <div className="bg-white rounded-xl p-6 main-shadow mb-6">
          <div className="">
            <div className="flex items-start justify-between mb-5  border-b-[#c3c3c3] border-b pb-4">
              <div>
                <p className="text-lg font-medium text-black mb-1">Order ID</p>
                <h3 className="text-base font-medium text-textcolor">
                   {order?.id ? `#${order?.id}` : ""}
                </h3>
              </div>
              <div className="flex gap-2">
                <button className="px-4 py-2 bg-gray-100 text-black text-sm font-medium rounded-lg border border-gray-300 transition-colors">
                 {getOrderStatus(order?.orderStatus)}
                </button>
                <button className="px-4 py-2 bg-primary text-white text-sm font-medium rounded-lg hover:bg-primary/90 transition-colors"
                onClick={()=> navigate(`/order-details/${order?.id}`)}
                >
                  View Details
                </button>
              </div>
            </div>

            {/* Order Details Grid */}
            <div className="grid grid-cols-5 gap-6 mb-4">
              <div>
                <p className="text-lg font-medium text-black mb-2">
                  Advertiser Name
                </p>
                <p className="text-lg font-normal text-textcolor">{order?.user?.name || "-"}</p>
              </div>
              <div>
                <p className="text-lg font-medium text-black mb-2">
                  Start Date
                </p>
                <p className="text-lg font-normal text-textcolor">{formatTimestamp(order?.subscriptionStartDate || "-")}</p>
              </div>
              <div>
                <p className="text-lg font-medium text-black mb-2">Plan</p>
                <p className="text-lg font-normal text-textcolor">
                  { order?.subscriptionDuration && order?.subscriptionDuration > 1 ? `${order?.subscriptionDuration} Months` : `${order?.subscriptionDuration} Month` }</p>
              </div>
              <div>
                <p className="text-lg font-medium text-black mb-2">
                  Geotargeting Fee
                </p>
                <p className="text-lg font-normal text-textcolor">{order?.geoTargetFee ? `$${ Number(order?.geoTargetFee) + Number(order?.geoTargetRecFee)}` : "-"}</p>
              </div>
              <div>
                <p className="text-lg font-medium text-black mb-2">Daypart</p>
                <p className="text-lg font-normal text-textcolor">{order?.daypart || "-"}</p>
              </div>
            </div>

            <div className="grid grid-cols-5 gap-6">
              <div>
                <p className="text-lg font-medium text-black mb-2">
                  Payment Type
                </p>
                <p className="text-lg font-normal text-textcolor">{order?.subscriptionDuration > 1 ? "Recurring" : "One Time" }</p>
              </div>
              <div>
                <p className="text-lg font-medium text-black mb-2">End Date</p>
                <p className="text-lg font-normal text-textcolor">{formatTimestamp(order?.subscriptionEndDate || "-")}</p>
              </div>
              <div>
                <p className="text-lg font-medium text-black mb-2">Duration</p>
                <p className="text-lg font-normal text-textcolor">{order?.displayDurationSeconds ? `${order?.displayDurationSeconds} secs` : "-"}</p>
              </div>
              <div>
                <p className="text-lg font-medium text-black mb-2">
                  Design Fee
                </p>
                <p className="text-lg font-normal text-textcolor">{order?.designFee ? `$${order?.designFee}` : "-"}</p>
              </div>
              <div>
                <p className="text-lg font-medium text-black mb-2"> Total Amount</p>
                <p className="text-lg font-normal text-textcolor">{order?.totalSubscriptionFee ? `$${(Number(order?.designFee) + Number(order?.geoTargetFee) + Number(order?.geoTargetRecFee) + Number(order?.totalSubscriptionFee))}` : "-" }</p>
              </div>
            </div>
        </div>
          </div>
        ))}
        </div>
      ) : (!loading &&
        <>        
        <div className="flex justify-center items-center mt-[60px]  ">
          <img
            src={ImagePath?.NoDataFound}
            alt="No Data Found"
            style={{ width: 70, height: 70 }}
          />
        </div>
        <p className="text-center text-lg font-medium text-textcolor mt-3">
          No Data Found
        </p>  
        </>
      )}
      <CommonPagination
        currentPage={currentPage}
        pageCount={totalCount}
        onPageChange={(e) => OnPageChange(e)}
      />
   
  </>
  );
};

export default OrdersTab;
